import { ProgramStatus } from "@/graphql";
import { cn } from "@/lib/utils";
import { MainProgram } from "@/types/programs";

import { ExecLead } from "./ExecLead";
import { ProgramLead } from "./LeadItem";
import { ProgramLeads } from "./ProgramLeads";
import { QuickActions } from "./QuickActions";

interface ProgramRightPanelProps {
  program: MainProgram;
  isLead: boolean;
  refetchProgram: () => void;
  quickActions: Array<"addComponent" | "addParticipants"> | null;
  showProgramLeads: boolean;
  showProgramLeadModification: boolean;
  showExecLead: boolean;
  execContact?: ProgramLead;
}

export function ProgramRightPanel({
  program,
  isLead = false,
  refetchProgram = () => {},
  quickActions = null,
  showProgramLeads = false,
  showProgramLeadModification = false,
  showExecLead = false,
  execContact,
}: ProgramRightPanelProps) {
  const activeProgram = [
    ProgramStatus.LaunchReady,
    ProgramStatus.Live,
    ProgramStatus.InDesign,
  ].includes(program.status || ProgramStatus.InDesign);

  return (
    <div className="mt-9">
      {program && activeProgram && quickActions && isLead && (
        <div
          className={`mb-4 pb-4 ${
            showProgramLeads || showExecLead ? "border-b" : ""
          }`}
        >
          <QuickActions
            actions={quickActions}
            program={program}
            isLead={isLead}
          />
        </div>
      )}

      {program?.programOwners && showProgramLeads && (
        <div className={cn("my-8 pb-8", showExecLead && "border-b")}>
          <ProgramLeads
            program={program}
            isLead={isLead}
            isClosed={!!program.closedAt}
            showModification={showProgramLeadModification}
            refetchProgram={refetchProgram}
          />
        </div>
      )}

      {showExecLead && <ExecLead execContact={execContact} />}
    </div>
  );
}
